// extracted by mini-css-extract-plugin
export default {"dropdownClass":"WeeklyReport_dropdownClass__c-NyH","addButton":"WeeklyReport_addButton__2PJ+T"};